import {
  Role,
  User,
} from 'types';
export const USER_ROLES = {
  Roles: [
    Role.SuperAdmin
   
  ],
  walletRoles: [Role.SuperAdmin],
  companyViewRoles: [Role.SuperAdmin],

  clientRoles: [Role.SuperAdmin],
  adminPortalRoles: [
    Role.SuperAdmin
   
  
  ],
  all: Object.values(Role),
};
export const allAvailableRolesExceptUser = (user: User) => {
  if (user.role === Role.SuperAdmin) {
    return USER_ROLES.all.filter(
      (role) => ![Role.SuperAdmin, Role.SuperAdmin].includes(role),
    );
  }

  return USER_ROLES.all.filter((role) => role !== Role.SuperAdmin);
};

export const allAvailableRolesForLoggedInUser = (user: User) => {
  if (user.role === Role.SuperAdmin) {
    return USER_ROLES.all.filter((role) => ![Role.SuperAdmin].includes(role));
  }

  return USER_ROLES.all;
};
export type PermissionKey = NestedKeyOf<Permissions>;











